export const ActionTypes = {
    SET_REGION_RULES: 'SET_REGION_RULES',
    SET_REGION_RULE: 'SET_REGION_RULE',
    SET_REGION_RULE_ACTIONS: 'SET_REGION_RULE_ACTIONS',
    SET_REGION_RULE_NOTIFICATIONS: 'SET_REGION_RULE_NOTIFICATIONS'
  };
